<mat-card appearance="outlined">
	<mat-card-title>Opiekun rezerwacji</mat-card-title>
	<mat-card-subtitle>{{ responsibleUserName }}</mat-card-subtitle>
	<button
		mat-icon-button
		[matMenuTriggerFor]="menu"
		class="position-absolute mt-3 top-0 end-0 responsibleUserMenuButton"
	>
		<i class="fas fa-ellipsis-vertical fs-4"></i>
	</button>
	<mat-menu #menu="matMenu">
		<button (click)="assignMe(loggedUser)" mat-menu-item>
			<span>Przypisz mnie</span>
		</button>
		<button class="setResponsibleUserButton" (click)="openDialog()" mat-menu-item>
			<span>Zmień opiekuna</span>
		</button>
	</mat-menu>
</mat-card>
